import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import SectionTopBar from 'components/global/SectionTopBar';

const SharedFilesTabs = [
  {
    key: 'files_from_clients',
    url: '/shared_files/files_from_clients',
    heading: <FormattedMessage defaultMessage="Files from Clients" />,
  },
  {
    key: 'files_to_clients',
    url: '/shared_files/files_to_clients',
    heading: <FormattedMessage defaultMessage="Files to Clients" />,
  },
  {
    key: 'files_to_all_clients',
    url: '/shared_files/files_to_all_clients',
    heading: <FormattedMessage defaultMessage="Files to All Clients" />,
  },
];

const TopBar = ({ activeTab }) => (
  <SectionTopBar
    title={<FormattedMessage defaultMessage="Shared Files" />}
    activeTab={activeTab}
    tabs={SharedFilesTabs}
  />
);

TopBar.propTypes = {
  activeTab: PropTypes.string.isRequired,
};

export default TopBar;
